import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Descansa con mayor profundidad y despierta con más energía.', 'Aprende hábitos sencillos que ayudan a regular tu respuesta al estrés.', 'Recupera claridad mental y mejora tu concentración.', 'Favorece un estilo de vida que contribuye a reducir la grasa abdominal asociada al estrés.'];
export const SolutionSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-white overflow-hidden" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-145">
          <motion.div className="mb-16 lg:mb-0 order-2 lg:order-1 relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-146">
            {/* Decorative accent block behind image */}
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-brand-mint/40 rounded-3xl hidden lg:block" aria-hidden="true" data-id="element-147" />
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-lightmint rounded-2xl hidden lg:block" aria-hidden="true" data-id="element-148" />

            <div className="relative w-full max-w-md mx-auto aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl" data-id="element-149">
              <img src="https://cdn.magicpatterns.com/uploads/gujv6zadQjdqGuAM3QYrya/ChatGPT_Image_17_may_2026,_02_14_59_p.m..png" alt="Mujer disfrutando una taza de té herbal en una cocina luminosa, relajada y sonriente" className="w-full h-full object-cover" data-id="element-150" />
            </div>
          </motion.div>

          <motion.div className="order-1 lg:order-2" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-151">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-brand-charcoal leading-tight mb-6" data-id="element-152">
              Empieza a recuperar el control de tu cuerpo en solo 21 días.
            </h2>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-153">
              <strong className="text-brand-charcoal" data-id="element-154">
                Resetea tu Cortisol en 21 Días
              </strong>{' '}
              es una guía práctica basada en hábitos respaldados por evidencia
              científica para ayudarte a reducir el impacto del estrés, mejorar
              tu descanso, recuperar tu energía y sentirte mejor, paso a paso.
            </p>

            <ul className="space-y-5" data-id="element-155">
              {benefits.map((benefit, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.15
            }} data-id="element-156">
                  <CheckCircle2 className="w-6 h-6 text-brand-emerald flex-shrink-0 mt-0.5" data-id="element-157" />
                  <span className="text-lg font-medium text-brand-charcoal" data-id="element-158">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <a href="#pricing" className="inline-block mt-10 px-8 py-4 text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-159">
              QUIERO COMENZAR HOY — $9.99
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
};